<template>
  <!-- 明細 -->
  <div class="billDetail">
    <div class="addPerson__wrap" v-show="visible">
      <el-header class="shadow page-header__wrap">
        <div class="flex">
          <div class="backBtn" @click="handleReturn">
            <el-image
              class="back-img"
              :src="require('@/assets/img/back.png')"
            ></el-image>
            <span>返回</span>
          </div>
          <div class="title">
            <span class="site">当前位置：</span>
            {{ $route.meta.title }}
            <span> > </span>
            供应商账单明细
          </div>
        </div>
      </el-header>

      <div class="main">
        <el-radio-group
          style="padding: 6px 0px 0px 6px"
          :size="subUnitSize"
          v-model="tabValue"
          class="tabsWrap"
          @change="handleTabs"
        >
          <el-radio-button :label="1">账单列表</el-radio-button>
          <el-radio-button :label="2">出入库列表</el-radio-button>
        </el-radio-group>
        <div class="mainBox" v-if="tabValue == 1">
          <div class="action-row">
            <div
              style="
                display: flex;
                align-items: center;
                margin-bottom: 10px;
                font-size: 14px;
                width: 100%;
              "
            >
              <div>
                <span style="color: #999">供应商名称：</span>
                <span style="color: #909399; font-weight: bold">{{
                  currRow.supplier_name
                }}</span>
              </div>
              <div style="margin-left: 20px">
                <span style="color: #999">交货日期：</span>
                <el-date-picker
                  v-model="table.params.day"
                  type="date"
                  size="mini"
                  style="width: 240px"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  @change="getTable"
                >
                </el-date-picker>
              </div>
              <div
                style="margin-left: 20px; display: flex; align-items: center"
              >
                <div style="color: #999; width: 120px">结清状态：</div>
                <el-select
                  v-model="table.params.settle_status"
                  clearable
                  :size="subUnitSize"
                  placeholder="请选择"
                  @change="getTable"
                >
                  <el-option label="全部" :value="0"> </el-option>
                  <el-option label="未结算" :value="1"> </el-option>
                  <el-option label="部分结清" :value="2"> </el-option>
                  <el-option label="已结清" :value="3"> </el-option>
                </el-select>
              </div>
              <div class="batch-settle-box">
                <el-button
                  class="margin-left:20px"
                  type="primary"
                  :size="subUnitSize"
                  @click="batchSettle"
                  >批量结清</el-button
                >
              </div>
            </div>
          </div>
          <el-table
            :data="table.data"
            style="width: 100%"
            :row-key="(row) => row.id"
            :key="tabValue"
            border
            size="mini"
            :header-cell-style="{ background: '#f5f5f5' }"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="center"
              :selectable="handleSelectable"
              type="selection"
              width="50"
            >
            </el-table-column>
            <el-table-column type="index" label="序号" width="60">
            </el-table-column>
            <el-table-column property="date" label="交货日期"></el-table-column>
            <el-table-column
              property="purchase_count"
              label="收货采购单/笔"
            ></el-table-column>
            <el-table-column
              property="total_order_num"
              label="下单数量"
            ></el-table-column>
            <el-table-column
              property="total_delivery_num"
              label="收货数量"
            ></el-table-column>
            <el-table-column
              property="total_delivery_money"
              label="收货金额(元)"
            ></el-table-column>
            <el-table-column
              property="freight_amount"
              label="垫付运费(元)"
            ></el-table-column>
            <el-table-column property="discount_amount" label="折扣金额(元)">
              <template slot-scope="{ row }">
                <el-popover trigger="click">
                  <el-button
                    slot="reference"
                    type="text"
                    v-if="row.settle_status !=3"
                    style="color: #409eff"
                    icon="el-icon-edit-outline"
                    >{{ row.discount_amount }}</el-button
                  >
                  <el-form class="staff-from">
                    <el-form-item label="修改折扣金额" prop="distr_date">
                      <el-input
                        placeholder="请输入"
                        v-model="discount_amount_pop"
                        clearable
                      >
                      </el-input>
                    </el-form-item>
                  </el-form>
                  <el-row type="flex" justify="center">
                    <el-button type="primary" @click="confirmEditDiscount(row)"
                      >确定</el-button
                    >
                  </el-row>
                </el-popover>
                <span v-if="row.settle_status ==3">{{ row.discount_amount }}</span>
              </template>
            </el-table-column>
            <el-table-column
              property="bill_amount"
              label="账单金额(元)"
            ></el-table-column>
            <el-table-column
              property="settle_amount"
              label="已结金额(元)"
            ></el-table-column>
            <el-table-column
              property="no_settle_amount"
              label="未结金额(元)"
            ></el-table-column>
            <el-table-column property="settle_status" label="结算状态">
              <template slot-scope="{ row }">
                <span>{{ getSettle_statusName(row.settle_status) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" prop="action" width="200">
              <template slot-scope="{ row }">
                <el-button type="text" @click="showDetail(row)"
                  >查看收货</el-button
                >
                <el-button
                  v-if="row.settle_status != 3"
                  type="text"
                  @click="clickSettle(row, true)"
                  >结清</el-button
                >
                <el-button
                  v-if="row.settle_status != 3"
                  type="text"
                  @click="clickSettle(row, false)"
                  >部分结清</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="mainBox table-container" v-else>
          <div style="margin-bottom: 6px" class="action-row table-header">
            <el-form
              ref="elFormDomC"
              inline
              :model="table.params"
              :size="subUnitSize"
              style="width: 100%"
            >
              <el-form-item label="供应商名称:">
                {{ currRow.supplier_name }}
              </el-form-item>
              <el-form-item label="" prop="type">
                <el-radio
                  v-model="tableC.params.type"
                  @change="getTableC"
                  label="1"
                  >只看入库</el-radio
                >
                <el-radio
                  v-model="tableC.params.type"
                  @change="getTableC"
                  label="2"
                  >只看出库</el-radio
                >
              </el-form-item>
              <el-form-item label="创建时间" prop="time">
                <el-date-picker
                  :size="subUnitSize"
                  v-model="tableC.params.time"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  @change="getTableC"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  class="selDaterangeWidth"
                  :clearable="false"
                  id="date"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="客户食堂" prop="address_id">
                <el-select
                  v-model="tableC.params.address_id"
                  filterable
                  @change="getTableC"
                  id="bind_id"
                  clearable
                  placeholder="请输入"
                >
                  <el-option
                    v-for="item in storeArrMM"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                    <span style="float: left">{{ item.name }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px"
                      >({{ item.merchant_name }})</span
                    >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="商品名称" prop="goods_name">
                <el-input
                  size="mini"
                  v-model.trim="tableC.params.goods_name"
                  placeholder="请输入"
                  clearable
                  @keydown.enter.native="getTableC"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  icon="el-icon-search"
                  @click="onSearchC"
                  >搜索</el-button
                >
                <el-button icon="el-icon-refresh-right" @click="resetC"
                  >重置</el-button
                >
              </el-form-item>
              <el-form-item style="float: right">
                <el-button @click="daochuC('/admin/bill/inventoryExport')"
                  >导出</el-button
                >
              </el-form-item>
            </el-form>
          </div>
          <el-table
            :data="tableC.data"
            :key="tabValue"
            class="table-content"
            style="width: 100%"
            border
            size="mini"
            :header-cell-style="{ background: '#f5f5f5' }"
          >
            <el-table-column
              property="good_name"
              label="标准名称"
            ></el-table-column>
            <el-table-column property="out_type" label="出入库类型">
              <template slot-scope="{ row }">
                <span>{{ row.type == 1 ? "入库" : "出库" }}</span> -
                <span>{{ statusArr[row.type][row.out_type] }}</span>
              </template>
            </el-table-column>
            <el-table-column
              property="source"
              label="来源/去向"
            ></el-table-column>
            <el-table-column property="change_quantity" label="数量">
              <template slot-scope="{ row }">
                <span>{{ row.change_quantity }}{{ row.unit_name }}</span>
              </template>
            </el-table-column>
            <el-table-column property="surplus_quantity" label="剩余库存">
              <template slot-scope="{ row }">
                <span>{{ row.surplus_quantity }}{{ row.unit_name }}</span>
              </template>
            </el-table-column>
            <el-table-column property="date" label="归属日期"></el-table-column>
            <el-table-column
              property="create_time"
              label="操作时间"
            ></el-table-column>
            <el-table-column
              property="account_name"
              label="操作人"
            ></el-table-column>
          </el-table>
          <div class="table-footer">
            <el-pagination
              @size-change="handleSizeChangeC"
              @current-change="handleCurrentChangeC"
              :current-page="tableC.params.page"
              :page-sizes="[10, 30, 100, 200]"
              :page-size="tableC.params.count"
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableC.total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="采购单收货信息"
      width="800px"
      class="dialog-box"
      center
      :modal="false"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :visible.sync="dialogTableVisible"
    >
      <el-table :data="tableData" border>
        <el-table-column type="index" label="序号" width="60">
        </el-table-column>
        <el-table-column property="order_no" label="采购单号" width="190">
          <template slot-scope="{ row }">
            <el-link type="primary" @click="showDetailPurchase(row)">{{
              row.order_no
            }}</el-link>
          </template>
        </el-table-column>
        <el-table-column
          property="spec_count"
          label="商品项数"
        ></el-table-column>
        <el-table-column
          property="total_order_num"
          label="下单数量"
        ></el-table-column>
        <el-table-column
          property="total_delivery_num"
          label="收货数量"
        ></el-table-column>
        <el-table-column
          property="total_delivery_money"
          label="收货金额(元)"
        ></el-table-column>
      </el-table>
    </el-dialog>

    <settleDialog ref="settleDialog" @update="update"></settleDialog>
    <!-- 采购单详情 -->
    <PurchaseDetail ref="purchasedetail"></PurchaseDetail>
  </div>
</template>

<script>
import settleDialog from "./settleDialog.vue";
import PurchaseDetail from "@/views/purchase/list/components/Details.vue";
import { mixinTable } from "@/mixins/table.js";
export default {
  name: "BuillDetail",
  props: ["sleDate"],
  mixins: [mixinTable],
  components: {
    PurchaseDetail,
    settleDialog,
  },
  data() {
    return {
      bankInfo:{},
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      visible: false,
      isChange: false,
      table: {
        params: {
          page: 1,
          count: 10,
          day: "",
          settle_status: "",
        },
        total: 0,
        data: [],
      },
      tableC: {
        params: {
          page: 1,
          count: 10,
          type: "",
          time: [],
          goods_name: "",
          address_id: "",
        },
        total: 0,
        data: [],
      },
      currRow: {},
      dialogTableVisible: false,
      tableData: [],
      multipleSelection: [], // 多选数据
      discount_amount_pop: "", // 折扣金额弹窗
      tabValue: 1,
      storeArrMM: [],
      statusArr: [
        [],
        [
          "",
          "采购入库",
          "创建入库",
          "转换单位",
          "退货入库",
          "盘点入库",
          "采购退货",
          "修改增加采购",
          "减少分拣",
          "净菜损耗",
          '修改供应商'
        ],
        [
          "",
          "正常出库",
          "环保处理",
          "转换单位",
          "退货入库",
          "盘点报损",
          "采购退货",
          "修改减少采购",
          "增加分拣",
          "净菜损耗",
          '修改供应商'
        ],
      ],
    };
  },
  methods: {
    handleTabs(val) {
      if (val == 1) {
        this.getTable();
      } else {
        this.getTableC();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getDetail(row) {
      this.currRow = row;
      this.getStoreSelMM();
      this.table.params.day = row.delivery_date; // 列表传进来的交货日期
      this.getTable();
    },
    reset(done) {
      this.isChange = false;
      // this.table.params.day = '';
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    // 单品汇总详情
    getTable() {
      let _params = {
        month: this.currRow.month, // 下单月份
        supplier_id: this.currRow.bind_id, // 供应商id
        day: this.table.params.day, // 下单日期
        settle_status: this.table.params.settle_status, // 结清状态
      };
      this.$http.get("/admin/bill/info", { params: _params }).then((res) => {
        if (res.code === 1) {
          this.table.loading = false;
          this.table.data = res.data.list;
          this.table.total = res.data.total;
          this.bankInfo = {
            bank_account:res.data.bank_account,
            bank_code:res.data.bank_code,
            bank_name:res.data.bank_name,
            tax_code:res.data.tax_code,
          }
        }
      });
    },
    //查看收货
    showDetail(row) {
      this.dialogTableVisible = true;
      let _params = {
        supplier_id: this.currRow.bind_id, // 供应商ID
        day: row.date,
        page: this.table.params.page,
        count: 999,
      };
      this.$http
        .get("/admin/bill/delivery", { params: _params })
        .then((res) => {
          if (res.code == 1) {
            this.tableData = res.data.list;
          }
        });
    },
    // 采购单详情
    showDetailPurchase(row) {
      // this.dialogTableVisible = false;
      let dom = this.$refs.purchasedetail;
      let obj = {
        id: row.purchase_id, //采购单id
        showType: 9999, // 公用组件，不展示底部操作按钮
      };
      dom.toggle(true);
      dom.getDetail(obj);
      dom = null;
    },
    // 返回
    handleReturn() {
      this.$emit("refresh");
      this.toggle(false);
      this.table.data = [];
      this.tabValue = 1;
    },
    batchSettle() {
      if (this.multipleSelection.length === 0)
        return this.$message.warning("请选择数据");
      let dom = this.$refs.settleDialog;
      dom.toggle(true);
      //塞入多选的数据
      dom.getDetail(this.multipleSelection, {...this.bankInfo,...this.currRow});
    },
    clickSettle(row, isAll) {
      let newRow = {
        ...row,
        supplier_id: this.currRow.bind_id,
        ...this.bankInfo,
      };
      this.$emit("showSettleDialog", newRow, isAll);
    },
    getSettle_statusName(status) {
      let statusMap = {
        1: "未结算",
        2: "部分结清",
        3: "已结清",
      };
      return statusMap[status];
    },
    handleSelectable(row) {
      if (row.settle_status === 3) {
        return false;
      }
      return true;
    },
    async confirmEditDiscount(row) {
      const params = {
        date: row.delivery_date,
        supplier_id: this.currRow.bind_id,
        discount_amount: this.discount_amount_pop,
      };
      let res = await this.$http.post("/admin/bill/setDiscount", params);
      console.log(res, "res");
      if (res.code == 1) {
        this.$message.success("修改成功");
        this.getTable();
        document.body.click();
      }
    },
    update() {
      this.getTable();
    },
    //出入库
    getTableC() {
      let params = {
        ...this.tableC.params,
        date: this.currRow.month,
        supplier_id: this.currRow.bind_id,
      };
      if (params.time.length) {
        params.start = params.time[0];
        params.end = params.time[1];
      } else {
        params.start = "";
        params.end = "";
      }
      delete params.time;
      this.$http.get("/admin/bill/inventory", { params }).then((res) => {
        if (res.code == 1) {
          this.tableC.data = res.data.list;
          this.tableC.total = res.data.total;
        }
      });
    },
    handleSizeChangeC(val) {
      this.tableC.params.page = 1;
      this.tableC.params.count = val;
      this.getTableC();
    },
    handleCurrentChangeC(val) {
      this.tableC.params.page = val;
      this.getTableC();
    },
    onSearchC() {
      this.getTableC();
    },
    resetC() {
      this.tableC.params.time = [];
      this.tableC.params.address_id = "";
      this.tableC.params.type = "";
      this.tableC.params.goods_name = "";
      this.$refs.elFormDomC.resetFields();
      this.table.params.page = 1;
      this.table.params.count = 10;
      this.getTableC();
    },
    daochuC(url) {
      let params = {
        ...this.tableC.params,
        date: this.currRow.month,
        supplier_id: this.currRow.bind_id,
      };
      if (params.time.length) {
        params.start = params.time[0];
        params.end = params.time[1];
      } else {
        params.start = "";
        params.end = "";
      }
      delete params.time;
      let str = "";
      Object.keys(params).forEach((item) => {
        str += `&${item}=${params[item]}`;
      });
      console.log(
        `${process.env.VUE_APP_BASE_API}${url}?token=${this.token}${str}`
      );
      window.open(
        `${process.env.VUE_APP_BASE_API}${url}?token=${this.token}${str}`
      );
    },
  },
  watch: {
    sleDate(val) {
      this.table.params.day = val;
      this.getTable();
    },
  },
};
</script>

<style scoped lang="scss">
.addPerson__wrap {
  @include position($t: 0, $r: 0, $b: 0, $l: 0);
}
.addPerson__wrap .main {
  overflow-x: hidden;
  background: #fff;
}
.returnBtn {
  z-index: 99;
  box-shadow: 0 0 8px 0 rgb(232 237 250 / 60%),
    0 2px 4px 0 rgb(232 237 250 / 50%);
}
.footerWrap {
  text-align: center;
  padding: 10px;
  box-shadow: 0 0 8px 0 rgb(232 237 250 / 60%),
    0 2px 4px 0 rgb(232 237 250 / 50%);
  z-index: 99;
}
.itemTime {
  display: block;
  margin-bottom: 10px;
  height: 30px;
  line-height: 30px;
}
.itemTime::before {
  content: "";
  width: 5px;
  height: 15px;
  background: #2cb167;
  border-radius: 6px;
  display: inline-block;
  margin-right: 10px;
  position: relative;
  top: 2px;
}
.flex {
  display: flex;
}
.mt20 {
  margin-top: 20px;
}
.mb20 {
  margin-bottom: 20px;
}
.width200px {
  width: 200px;
}
.after-table {
  padding: 10px;
  font-size: 13px;
  color: #303030;
  text-align: right;
}
.pageWrap {
  margin-top: 10px;
  text-align: right;
  margin-right: 36px;
}
.dialog-box {
  z-index: 8 !important;
}

.billDetail ::v-deep .v-modal {
  z-index: 7 !important;
}
.action-row {
  display: flex;
  // justify-content: space-between;
}
.batch-settle-box {
  flex: 1;
  text-align: right;
}

.table-container {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 180px); /* 根据实际情况调整高度 */
}

.table-header {
  flex: 0 0 auto;
}

.table-content {
  flex: 1;
  overflow: auto;
}

.table-footer {
  flex: 0 0 auto;
  display: flex;
  justify-content: flex-end;
  padding: 10px 50px 10px 0;
}
</style>
